<template>
  <div class="pageMyReservation">
    <h2 class="incloudeBtn">{{ $t("pages.wording.reserve") }}</h2>
    <!--我的預約單-->
    <el-form label-width="150px">
      <div class="boxContain c-form searchBar">
        <el-row :gutter="24">
          <el-col :span="9">
            <el-form-item :label="$t('pages.wording.reserveNo')"
              ><!--deltaContactName-->
              <el-input
                :placeholder="$t('pages.wording.queryReserveNum')"
                v-model.trim="searchForm.reserveNo"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item :label="$t('pages.wording.reserveDate')"
              ><!--deltaContactName-->
              <el-date-picker
                v-model="searchForm.reserveArriveTime"
                type="daterange"
                range-separator="-"
                :start-placeholder="$t('pages.wording.startDate')"
                :end-placeholder="$t('pages.wording.endDate')"
                clearable
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
                ><!--開始日期/結束日期-->
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-button class="blue-button" @click="searchTable()" type="primary">{{
              $t("pages.button.search")
            }}</el-button>
          </el-col>
        </el-row>
      </div>
      <!--boxContain-->
    </el-form>
    <div class="boxContain c-table includeBtn delta_table">
      <div class="c-table-top-right-btn" v-if="!readOnly">
        <el-button class="blue-button" icon="el-icon-plus" @click="creatReservation()" type="primary">{{
          $t("pages.button.createReserve")
        }}</el-button
        ><!--新增申請單-->
      </div>
      <el-tabs v-model="activeName" @tab-click="tabClick">
        <el-tab-pane label="preProcess" name="first">
          <span slot="label"
            ><i class="el-icon-takeaway-box"></i>{{ $t("pages.wording.preProccess") }}({{
              preProcessTableData.length
            }})</span
          ><!--待處理-->
          <div class="s-table">
            <template>
              <el-table
                v-loading="loading"
                :data="preProcessNewTableData"
                border
                style="width: 100%"
                height="500px"
                @current-change="applyPageCheck"
                @sort-change="PreProcessChangeSort"
              >
                <el-table-column :label="$t('pages.wording.action')" width="80"
                  ><!--編輯-->
                  <template slot-scope="scope">
                    <div v-if="!readOnly">
                      <el-button @click="reservationDelete(scope.row)" type="text" size="medium">
                        <i class="el-icon-delete"></i>
                      </el-button>
                      <el-button type="text" size="medium">
                        <i class="el-icon-edit"></i>
                      </el-button>
                    </div>
                    <div v-else>
                      <el-button @click="reservationView(scope.row)" type="text" size="medium">
                        <i class="el-icon-tickets"></i>
                      </el-button>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="OACode" :label="$t('pages.wording.oaCode')" width="80"> </el-table-column
                ><!--OA Code-->
                <el-table-column prop="vendor" :label="$t('pages.wording.vendor')" width="300"> </el-table-column
                ><!--公司名稱-->
                <el-table-column
                  :sortable="'custom'"
                  prop="reserveArriveDate"
                  :label="$t('pages.wording.reserveArriveDate')"
                  width="160"
                  ><!--預約進廠時間-->
                  <template slot-scope="scope">
                    {{ formateDatetimeStr("DateTime", scope.row.reserveArriveDatetime) }}
                  </template>
                </el-table-column>
                <el-table-column prop="reserveFactory" :label="$t('pages.wording.factory')" width="90">
                </el-table-column
                ><!--廠別-->
                <el-table-column
                  prop="enterReason"
                  label-class-name="header_label"
                  :label="$t('pages.wording.enterReason')"
                  width="100"
                >
                  <template slot-scope="scope" v-if="scope.row.reserveArriveDatetime != null">
                    {{ $store.getters.getSysCodeText("enterReason", scope.row.enterReason) }}
                  </template></el-table-column
                ><!--入廠事由-->
                <el-table-column
                  prop="deltaContactName"
                  label-class-name="header_label"
                  :label="$t('pages.wording.deltaContactName')"
                  minWidth="95"
                  maxWidth="220"
                >
                </el-table-column
                ><!--台達接洽人-->
                <el-table-column prop="showStatus" :label="$t('pages.wording.reserveStatus')" width="150"
                  ><!--狀態-->
                  <template slot-scope="scope">
                    {{ $t("reserve.status." + scope.row.reserveStatus) }}
                  </template>
                </el-table-column>
                <el-table-column
                  :sortable="'custom'"
                  prop="applyDate"
                  :label="$t('pages.wording.applyDate')"
                  width="120"
                >
                  <template slot-scope="scope">
                    {{ formateDatetimeStr("Date", scope.row.applyDatetime) }}
                  </template> </el-table-column
                ><!--填單日期-->
              </el-table>
            </template>
            <el-pagination
              :pager-count="pages.pageCount"
              :page-size="pages.pageSize"
              :current-page.sync="pages.preProcessTablePage.pageCurrent"
              layout="prev, pager, next"
              :total="pages.preProcessTablePage.pageTotal"
              @current-change="changePagePreProcessTable"
            >
            </el-pagination>
          </div>
          <!--s-table-->
        </el-tab-pane>
        <el-tab-pane label="inProcess" name="second">
          <span slot="label"
            ><i class="el-icon-receiving"></i>{{ $t("pages.wording.inProccess") }}({{
              inProcessTableData.length
            }})</span
          ><!--處理中-->
          <div class="s-table">
            <template>
              <el-table
                :data="inProcessNewTableData"
                border
                style="width: 100%"
                height="500px"
                @current-change="applyPageCheck"
                @sort-change="InProcessChangeSort"
              >
                <el-table-column :label="$t('pages.wording.action')" width="80"
                  ><!--編輯-->
                  <template slot-scope="scope">
                    <div v-if="!readOnly">
                      <el-button
                        v-if="scope.row.reserveStatus == 'vendorComfirm' || scope.row.reserveStatus == 'entering'"
                        @click="reservationDelete(scope.row)"
                        type="text"
                        size="medium"
                      >
                        <i class="el-icon-delete"></i>
                      </el-button>
                      <el-button
                        v-if="scope.row.reserveStatus == 'vendorComfirm' || scope.row.reserveStatus == 'entering'"
                        type="text"
                        size="medium"
                      >
                        <i class="el-icon-edit"></i>
                      </el-button>
                      <el-button v-else @click="reservationView(scope.row)" type="text" size="medium">
                        <i class="el-icon-tickets"></i>
                      </el-button>
                    </div>
                    <div v-else>
                      <el-button @click="reservationView(scope.row)" type="text" size="medium">
                        <i class="el-icon-tickets"></i>
                      </el-button>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="reserveNo" :label="$t('pages.wording.reserveNo')" width="130"> </el-table-column
                ><!--單號-->
                <el-table-column prop="releaseOrder" :label="$t('pages.wording.releaseOrder')" width="120">
                  <template
                    slot-scope="scope"
                    v-if="scope.row.reserveType == 'ERP' || scope.row.reserveType == 'ERP_ONE'"
                  >
                    <span class="releaseBtn" @click="getReleaseOrderList(scope.row)">{{
                      $t("pages.wording.releaseOrder")
                    }}</span>
                  </template> </el-table-column
                ><!--單號-->
                <el-table-column prop="OACode" :label="$t('pages.wording.oaCode')" width="80"> </el-table-column
                ><!--OA Code-->
                <el-table-column prop="vendor" :label="$t('pages.wording.vendor')" width="150"> </el-table-column
                ><!--公司名稱-->
                <el-table-column
                  sortable
                  prop="reserveArriveDate"
                  :label="$t('pages.wording.reserveArriveTime')"
                  width="190"
                  ><!--預約進廠時間-->
                  <template slot-scope="scope">
                    {{ formateDatetimeStr("DateTime", scope.row.reserveArriveDatetime) }}
                  </template>
                </el-table-column>
                <el-table-column prop="reserveFactory" :label="$t('pages.wording.factory')" width="80">
                </el-table-column
                ><!--廠別-->
                <el-table-column prop="enterReason" :label="$t('pages.wording.enterReason')" width="150">
                  <template slot-scope="scope" v-if="scope.row.reserveArriveDatetime != null">
                    {{ $store.getters.getSysCodeText("enterReason", scope.row.enterReason) }}
                  </template></el-table-column
                ><!--入廠事由-->
                <el-table-column
                  prop="deltaContactName"
                  label-class-name="header_label"
                  :label="$t('pages.wording.deltaContactName')"
                  minWidth="95"
                  maxWidth="220"
                >
                </el-table-column
                ><!--台達接洽人-->
                <el-table-column prop="showStatus" :label="$t('pages.wording.reserveStatus')" width="150"
                  ><!--狀態-->
                  <template slot-scope="scope">
                    {{ $t("reserve.status." + scope.row.reserveStatus) }}
                  </template>
                </el-table-column>
                <el-table-column sortable prop="applyDate" :label="$t('pages.wording.applyDate')" width="120">
                  <template slot-scope="scope">
                    {{ formateDatetimeStr("Date", scope.row.applyDatetime) }}
                  </template> </el-table-column
                ><!--填單日期-->
              </el-table>
            </template>
            <el-pagination
              :pager-count="pages.pageCount"
              :page-size="pages.pageSize"
              :current-page.sync="pages.inProcessTablePage.pageCurrent"
              layout="prev, pager, next"
              :total="pages.inProcessTablePage.pageTotal"
              @current-change="changePageInProcessTable"
            >
            </el-pagination>
          </div>
          <!--s-table-->
        </el-tab-pane>
        <el-tab-pane label="finish" name="third">
          <span slot="label"
            ><i class="el-icon-check"></i>{{ $t("pages.wording.finish") }}({{ finishTableData.length }})</span
          ><!--已完成-->
          <div class="s-table">
            <template>
              <el-table
                :data="finishNewTableData"
                border
                style="width: 100%"
                height="500px"
                @current-change="applyReserveInfo"
                @sort-change="FinishChangeSort"
              >
                <el-table-column :label="$t('pages.wording.action')" width="80"
                  ><!--編輯-->
                  <template slot-scope="scope">
                    <el-button @click="reservationView(scope.row)" type="text" size="medium">
                      <i class="el-icon-tickets"></i>
                    </el-button>
                  </template>
                </el-table-column>
                <el-table-column prop="reserveNo" :label="$t('pages.wording.reserveNo')" width="130"> </el-table-column
                ><!--單號-->
                <el-table-column prop="releaseOrder" :label="$t('pages.wording.releaseOrder')" width="120">
                  <template
                    slot-scope="scope"
                    v-if="scope.row.reserveType == 'ERP' || scope.row.reserveType == 'ERP_ONE'"
                  >
                    <span class="releaseBtn" @click="getReleaseOrderList(scope.row)">{{
                      $t("pages.wording.releaseOrder")
                    }}</span>
                  </template> </el-table-column
                ><!--單號-->
                <el-table-column prop="OACode" :label="$t('pages.wording.oaCode')" width="80"> </el-table-column
                ><!--OA Code-->
                <el-table-column prop="vendor" :label="$t('pages.wording.vendor')" width="150"> </el-table-column
                ><!--公司名稱-->
                <el-table-column
                  sortable
                  prop="reserveArriveDate"
                  :label="$t('pages.wording.reserveArriveTime')"
                  width="190"
                  ><!--預約進廠時間-->
                  <template slot-scope="scope">
                    {{ formateDatetimeStr("DateTime", scope.row.reserveArriveDatetime) }}
                  </template>
                </el-table-column>
                <el-table-column prop="reserveFactory" :label="$t('pages.wording.factory')" width="80">
                </el-table-column
                ><!--廠別-->
                <el-table-column prop="enterReason" :label="$t('pages.wording.enterReason')" width="150">
                  <template slot-scope="scope" v-if="scope.row.reserveArriveDatetime != null">
                    {{ $store.getters.getSysCodeText("enterReason", scope.row.enterReason) }}
                  </template></el-table-column
                ><!--入廠事由-->
                <el-table-column
                  prop="deltaContactName"
                  label-class-name="header_label"
                  :label="$t('pages.wording.deltaContactName')"
                  minWidth="95"
                  maxWidth="220"
                >
                </el-table-column
                ><!--台達接洽人-->
                <el-table-column prop="reserveStatus" :label="$t('pages.wording.reserveStatus')" width="150"
                  ><!--狀態-->
                  <template slot-scope="scope">
                    {{ $t("reserve.status." + scope.row.reserveStatus) }}
                  </template>
                </el-table-column>
                <el-table-column sortable prop="applyDate" :label="$t('pages.wording.applyDate')" width="120">
                  <template slot-scope="scope">
                    {{ formateDatetimeStr("Date", scope.row.applyDatetime) }}
                  </template> </el-table-column
                ><!--填單日期-->
              </el-table>
            </template>
            <el-pagination
              :pager-count="pages.pageCount"
              :page-size="pages.pageSize"
              :current-page.sync="pages.finishTablePage.pageCurrent"
              layout="prev, pager, next"
              :total="pages.finishTablePage.pageTotal"
              @current-change="changePageFinishTable"
            >
            </el-pagination>
          </div>
          <!--s-table-->
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-dialog :title="$t('pages.wording.releaseOrder')" :visible.sync="dialog.releaseOrder" width="50%">
      <el-table
        class="dialogReleaseOrder"
        :data="releasTableData"
        border
        style="width: 90%"
        height="300px"
        @current-change="applyReleaseForm"
        :default-sort="{ prop: 'saleDate', order: 'descending' }"
      >
        <el-table-column prop="releaseOrderNo" :label="$t('pages.wording.releaseNumber')" width=""> </el-table-column
        ><!--廠別-->
        <el-table-column prop="SO" label="SO No." width="100"> </el-table-column
        ><!--廠別-->
        <el-table-column prop="saleDate" :label="$t('pages.wording.salesDate')" width="120"> </el-table-column
        ><!--廠別-->
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialog.releaseOrder = false">{{ $t("pages.button.confirm") }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { utils } from "@/utils/utils.js"
import { role } from "@/config/role.js"
import { mapGetters } from "vuex"
import { api } from "@/utils/api.js"
export default {
  name: "PageMyReservation",
  data() {
    return {
      readOnly: false,
      activeName: "first",
      preProcessTableData: [],
      preProcessNewTableData: [],
      inProcessTableData: [],
      inProcessNewTableData: [],
      finishTableData: [],
      finishNewTableData: [],
      releasTableData: [],
      dialog: {
        releaseOrder: false,
      },
      searchForm: {
        reserveArriveTime: [],
        reserveNo: "",
      },
      pages: {
        pageCount: 5,
        pageSize: 20,
        preProcessTablePage: {
          pageTotal: 35,
          pageCurrent: 1,
        },
        inProcessTablePage: {
          pageTotal: 35,
          pageCurrent: 1,
        },
        finishTablePage: {
          pageTotal: 35,
          pageCurrent: 1,
        },
      },
      loading: false,
      user: {
        region: null,
        area: null,
        factory: null,
      },
    }
  },
  created() {
    this.init()
  },
  methods: {
    ...mapGetters(["getUserProfile", "getUserRoles"]),
    /***************-GENERAL-***************/
    init() {
      let userRoles = this.getUserRoles()
      this.user.region = utils.getFirstOrDefault(this.getUserProfile().region)
      this.user.area = this.getUserProfile().area
      this.user.factory = this.getUserProfile().factory

      this.queryTable()
      if (userRoles.length === 1 && userRoles.includes(role.GUARD_LEAD)) {
        this.readOnly = true
      }
    },
    tabClick(tab, event) {
      console.log(tab, event)
    },
    /***************-PAGING-***************/
    changePagePreProcessTable(val) {
      this.preProcessNewTableData = utils.buildPagingTable(this.preProcessTableData, val, this.pages.pageSize)
    },
    changePageInProcessTable(val) {
      this.inProcessNewTableData = utils.buildPagingTable(this.inProcessTableData, val, this.pages.pageSize)
    },
    changePageFinishTable(val) {
      this.finishNewTableData = utils.buildPagingTable(this.finishTableData, val, this.pages.pageSize)
    },
    PreProcessChangeSort(cols) {
      utils.sortChangeMethod(cols, this.preProcessTableData)
      this.preProcessNewTableData = utils.buildPagingTable(
        this.preProcessTableData,
        this.pages.preProcessTablePage.pageCurrent,
        this.pages.pageSize
      )
    },
    InProcessChangeSort(cols) {
      utils.sortChangeMethod(cols, this.inProcessTableData)
      this.inProcessNewTableData = utils.buildPagingTable(
        this.inProcessTableData,
        this.pages.inProcessTablePage.pageCurrent,
        this.pages.pageSize
      )
    },
    FinishChangeSort(cols) {
      utils.sortChangeMethod(cols, this.finishTableData)
      this.finishNewTableData = utils.buildPagingTable(
        this.finishTableData,
        this.pages.finishTablePage.pageCurrent,
        this.pages.pageSize
      )
    },
    /***************-FORM ACTIVE-***************/
    queryTable() {
      let userAD = this.getUserProfile().userAD
      let todaydate = new Date()
      let y = todaydate.getFullYear()
      let m = todaydate.getMonth()
      let d = todaydate.getDate()
      let firstDate = utils.getDateTime(utils.getDateAfterAddDays(new Date(y, m, d, 0, 0), -1))
      let lastDate = utils.getDateTime(utils.getDateAfterAddDays(new Date(y, m, d, 23, 59), 5))
      let firstDatetime = utils.getISOString(firstDate[0] + " " + firstDate[1])
      let lastDatetime = utils.getISOString(lastDate[0] + " " + lastDate[1])
      let parameter = {
        reserveAreaList: this.user.area,
        reserveFactory: this.user.factory,
        multi_arearole_query: this.getUserProfile().areaRights,
        userAD: userAD,
        reserveArriveTimeStart: firstDatetime,
        reserveArriveTimeEnd: lastDatetime, //SA要以進廠日期, 但ERP產生預約單沒有預約進廠日期 會查不到
      }
      this.callGetUserReserveTable(parameter)

      //查詢預設
      this.searchForm.reserveArriveTime = [
        utils.parseISOStringToDate(firstDatetime),
        utils.parseISOStringToDate(lastDatetime),
      ]
    },
    searchTable() {
      let userAD = this.getUserProfile().userAD
      let parameter = {
        reserveAreaList: this.user.area,
        reserveFactory: this.user.factory,
        reserveStatus: ["temporary", "cancel", "vendorComfirm", "entering", "in1", "in2", "finished", "enteringFail"],
        reserveNo: this.searchForm.reserveNo,
        multi_arearole_query: this.getUserProfile().areaRights,
        userAD: userAD,
      }

      if (this.searchForm.reserveArriveTime != null && this.searchForm.reserveArriveTime.length != 0) {
        parameter.reserveArriveTimeStart = utils.getISOString(
          utils.getDateTime(new Date(this.searchForm.reserveArriveTime[0]))[0] + " 00:00"
        )
        parameter.reserveArriveTimeEnd = utils.getISOString(
          utils.getDateTime(new Date(this.searchForm.reserveArriveTime[1]))[0] + " 23:59"
        )
      }
      this.callGetUserReserveTable(parameter)
    },
    callGetUserReserveTable(params) {
      let vueInstance = this
      vueInstance.loading = true
      api
        .apiGetMyReserveTable(params)
        .then((response) => {
          let reserveList = response.data.result
          if (reserveList.length === 0) {
            vueInstance.finishNewTableData = []
            vueInstance.preProcessNewTableData = []
            vueInstance.inProcessNewTableData = []
            vueInstance.finishTableData = []
            vueInstance.preProcessTableData = []
            vueInstance.inProcessTableData = []
          } else {
            vueInstance.finishTableData = []
            vueInstance.preProcessTableData = []
            vueInstance.inProcessTableData = []

            reserveList.forEach((item) => {
              switch (item.reserveStatus) {
                case "temporary":
                  vueInstance.preProcessTableData.push(item)
                  break
                case "vendorComfirm":
                case "entering":
                case "in1":
                case "in2":
                  vueInstance.inProcessTableData.push(item)
                  break
                case "finished":
                case "enteringFail":
                case "cancel":
                  vueInstance.finishTableData.push(item)
                  break
              }
            })
            vueInstance.pages.preProcessTablePage.pageTotal = vueInstance.preProcessTableData.length
            vueInstance.preProcessNewTableData = utils.buildPagingTable(
              vueInstance.preProcessTableData,
              vueInstance.pages.preProcessTablePage.pageCurrent,
              vueInstance.pages.pageSize
            )

            vueInstance.pages.inProcessTablePage.pageTotal = vueInstance.inProcessTableData.length
            vueInstance.inProcessNewTableData = utils.buildPagingTable(
              vueInstance.inProcessTableData,
              vueInstance.pages.inProcessTablePage.pageCurrent,
              vueInstance.pages.pageSize
            )

            vueInstance.pages.finishTablePage.pageTotal = vueInstance.finishTableData.length
            vueInstance.finishNewTableData = utils.buildPagingTable(
              vueInstance.finishTableData,
              vueInstance.pages.finishTablePage.pageCurrent,
              vueInstance.pages.pageSize
            )
          }
          vueInstance.loading = false
        })
        .catch(function (e) {
          console.log(e)
        })
    },
    applyPageCheck(val) {
      if (
        (val.reserveStatus == "vendorComfirm" || val.reserveStatus == "entering" || val.reserveStatus == "temporary") &&
        !this.readOnly
      ) {
        this.applyReserveTempForm(val)
      } else {
        this.applyReserveInfo(val)
      }
    },
    applyReserveTempForm(val) {
      this.$router.push({
        name: "PageMyReservationTempForm",
        params: val,
      })
    },
    applyReserveInfo(val) {
      this.$router.push({
        name: "PageMyReservationInfo",
        params: val,
      })
    },
    creatReservation() {
      this.$router.push({
        name: "PageMyReservationTempForm",
        params: { id: 0 },
      })
    },
    reservationEdit(row) {
      console.log(row)
    },
    reservationView(row) {
      this.$router.push({
        name: "PageMyReservationInfo",
        params: row,
      })
    },
    reservationDelete(dataRow) {
      let e = window.event
      let vm = this
      e.stopPropagation()
      vm.$confirm(vm.$t("message.alert.warnDelete"))
        .then((_) => {
          let params = {
            reserveType: dataRow.reserveType,
            nowStatus: dataRow.reserveStatus,
            reserveID: dataRow.id,
            isPass: false,
            inputJsonObject: {
              reserveData: dataRow,
            },
          }
          utils.showLoading(vm)
          api
            .apiUpdateReserveFlow(params)
            .then((response) => {
              if (response.data) {
                utils.closeLoading(vm)
                if (response.data.success) {
                  vm.$message({
                    message: vm.$t("message.alert.successDelete"),
                    type: "success",
                  })
                  vm.queryTable()
                } else {
                  vm.$alert(vm.$t("pages.wording.occursWhenProcessReserveFlow"), "", {
                    confirmButtonText: vm.$t("pages.button.confirm"),
                  })
                }
              }
            })
            .catch((error) => {
              console.log(error)
              utils.closeLoading(vm)
            })
        })
        .catch((_) => {})
    },
    getReleaseOrderList(row) {
      let e = window.event
      e.stopPropagation()

      let parameter = {
        reserveRef: row.id,
      }
      this.$store.dispatch("getReleaseTable", parameter)
    },
    applyReleaseForm(val) {
      this.$router.push({
        name: "PageMyReleaseOrderForm",
        params: val,
      })
    },
    formateDatetimeStr(type, dtstring) {
      return utils.getFormateDateTime(type, dtstring)
    },
    labelHead(h, { column }) {
      let l = column.label.length
      let f = 10
      column.minWidth = f * (l + 2)
      return h("span", { class: "table-head", style: { width: "100%" } }, [column.label])
    },
  },
  watch: {
    "$store.getters.alertMessage": function (val) {
      let code = val.code
      let message = val.message
      let cb = val.cb
      let title = code == 0 ? "success" : "fail"
      utils.alertMessage(this, code, message, title, cb)
    },
    "$store.getters.storeCallback": function (val) {
      val.fn()
    },
    "$store.getters.releaseTable": function (val) {
      this.releasTableData = val
      this.dialog.releaseOrder = true
    },
  },
}
</script>

<style>
.c-table {
  position: relative;
}
.c-table .el-tabs__item {
  font-size: 14px;
  font-weight: 500;
  color: #dceaf8;
  height: 50px;
  line-height: 50px;
}
.c-table .el-tabs__item i {
  margin-right: 10px;
  font-size: 20px;
}
.c-table .el-tabs__header {
  background: #00a0e9;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  margin: 0px;
}
.c-table .el-tabs__nav {
  margin-left: 20px;
}
.c-table .el-tabs__item.is-active {
  color: #fff;
}
.c-table .el-tabs__nav-wrap::after {
  background-color: #002752;
}
.c-table .el-tabs__active-bar {
  width: 120px;
  background-color: #fff;
}
.c-table .el-table th {
  background: #f5f5f5;
}
.c-table .el-button--medium {
  font-size: 17px;
}
.el-pagination {
  text-align: right;
}
.c-table .el-table__fixed-right-patch {
  background: #f5f5f5;
}
.c-table .el-dialog,
.c-table .el-pager li,
.c-table .el-pagination .btn-next,
.c-table .el-pagination .btn-prev {
  background: none;
}
.c-table-top-right-btn .el-button {
  position: absolute;
  top: 4px;
  right: 10px;
  z-index: 99;
}

h2 {
  margin: 0 0 2rem;
}
.c-form .el-row .searchBar {
  line-height: 40px;
}
.releaseBtn {
  border: 1px #7d7d7d solid;
  padding: 2px 8px;
  display: inline-block;
}
#app .dialogReleaseOrder {
  margin: 0px auto;
  border: 1px #ccc solid;
}
#app .dialogReleaseOrder th {
  background-color: #f5f5f5;
  font-weight: bolder;
}
</style>
